var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "productCard wh-100 flex-between-start flex-column no-user-select",
      class: { inactive: !_vm.child.product.av },
    },
    [
      _c("div", { staticClass: "productCard-top-body-grouped w-100" }, [
        _c("div", { staticClass: "productCard-top w-100 bg-bo-grey5" }, [
          _c(
            "div",
            { staticClass: "productPicHover no-overflow wh-100 pos-relative" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "productImg pos-absolute wh-100 flex-center-center",
                },
                [
                  _vm.child.product.ims
                    ? _c("img", {
                        staticClass: "img-fit wh-100",
                        attrs: {
                          src: _vm.UrlService.imagePath(
                            _vm.child.product.ShopId,
                            _vm.child.product.ims
                          ),
                          alt: _vm.child.product.dn,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.child.product.ims,
                        expression: "!child.product.ims",
                      },
                    ],
                    staticClass: "noPic",
                    attrs: { src: _vm.noPicUrl, alt: _vm.child.product.dn },
                  }),
                  _vm._v(" "),
                  !_vm.imageOnly && _vm.child.product.Promo
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "discountBadge radius-circle bg-bo-p2 shadow-1 flex-center-center pos-absolute top-0 right-0 m-10",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "color-white fsize-13 text-sbold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.ShopService.shop.info.labels
                                    .PromotionInitials
                                )
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              !_vm.readOnly && !_vm.imageOnly
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "touch",
                          rawName: "v-touch",
                          value: _vm.getEditHandler(_vm.child),
                          expression: "getEditHandler(child)",
                        },
                      ],
                      staticClass:
                        "hover-actions pos-relative wh-100 gradient-shadow2 flex-start-end",
                      on: {
                        click: function ($event) {
                          return _vm.edit(_vm.child)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "hover-actions--btns flex-between-center color-white fsize-20 w-100 p-10",
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fie-icon_trash hover-2 cursor-pointer",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleRemoveItem()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fie-icon_duplicate hover-bo-s2 mx-5 cursor-pointer",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.duplicate(_vm.child)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fie-icon_edit hover-1 cursor-pointer",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.edit(_vm.child)
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.deleteItemIsOpen,
                      expression: "deleteItemIsOpen",
                    },
                  ],
                  staticClass:
                    "bg-bo-danger wh-100 pos-absolute zindex-2 left-0 ease-5",
                  class: {
                    "opacity-1 top-0": _vm.deleteItemIsOpen,
                    "opacity-0 top-100": !_vm.deleteItemIsOpen,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-center-center flex-column wh-100" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-white fsize-12 text-sbold text-italic text-center p-10 mb-10 w-100",
                        },
                        [_vm._v("Supprimer ?")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-between-center" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-white hover-opacity cursor-pointer p-10 no-line-height",
                            attrs: { title: "Supprimer" },
                            on: {
                              click: function ($event) {
                                _vm.toggleRemoveItem()
                                _vm.deleteItem(_vm.child)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fie-icon_v fsize-18" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-white hover-opacity cursor-pointer p-10 no-line-height",
                            attrs: { title: "Annuler" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleRemoveItem()
                              },
                            },
                          },
                          [_c("i", { staticClass: "fie-icon_close fsize-16" })]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "productCard-body pos-relative w-100 px-10 py-20" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch",
                    value: _vm.setCurrent,
                    expression: "setCurrent",
                  },
                ],
                staticClass: "flex-between-start cursor-pointer",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.setCurrent()
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "productCard-title color-grey1 fsize-13 text-wrap text-capitalize mb-5",
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.truncate(_vm.child.product.dn, {
                            length: _vm.DISPLAY_LENGTH.mosaic.product.title,
                          })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.imageOnly && _vm.isLimited(_vm.child)
                      ? _c("div", { staticClass: "text-warning" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\tMax " +
                              _vm._s(_vm.ShopService.shop.MaxNumberCommands) +
                              " par " +
                              _vm._s(_vm.ShopService.shop.DeliveryTimeSlot) +
                              " minutes\n\t\t\t\t\t"
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "fsize-20 flex-shrink-0" }, [
                  _vm.child.product.ty === 1
                    ? _c("i", { staticClass: "color-grey1 fie-icon_folder" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.child.product.ty === 2
                    ? _c("i", { staticClass: "color-bo-p2 fie-icon_foods" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.child.product.ty === 3
                    ? _c("i", { staticClass: "color-bo-s2 fie-icon_cards" })
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            !_vm.imageOnly
              ? _c(
                  "div",
                  {
                    staticClass:
                      "productCard-desc text-italic fsize-9 color-bo-grey2 text-wrap",
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.child.product.dd &&
                            _vm.child.product.dd.substring(
                              0,
                              _vm.DISPLAY_LENGTH.mosaic.product.desc
                            )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.child.product.dd &&
                    _vm.child.product.dd.length >
                      _vm.DISPLAY_LENGTH.mosaic.product.desc
                      ? _c("span", [_vm._v("...")])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      !_vm.imageOnly && !_vm.readOnly
        ? _c("div", { staticClass: "productCard-bottom w-100 px-10 pb-10" }, [
            _vm.child.product.allergens.length ||
            _vm.child.product.consumables.length
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex-center-center fsize-9 color-bo-p1 mb-15 bg-bo-grey5 radius-4",
                  },
                  [
                    _vm.child.product.allergens.length > 1
                      ? _c("div", [_vm._v("Allergènes")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.child.product.allergens.length === 1
                      ? _c("div", [_vm._v("Allergène")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.child.product.allergens.length &&
                    _vm.child.product.consumables.length
                      ? _c("div", { staticClass: "mx-5" }, [_vm._v("&")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.child.product.consumables.length > 1
                      ? _c("div", [_vm._v("Consommables")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.child.product.consumables.length === 1
                      ? _c("div", [_vm._v("Consommable")])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "flex-between-center w-100" }, [
              _c(
                "div",
                {
                  staticClass: "drag size-w-35",
                  class: { invisible: _vm.UiService.isMobileView },
                  attrs: { "sv-handle": "" },
                },
                [_c("i", { staticClass: "fie-icon_3lines-h" })]
              ),
              _vm._v(" "),
              _vm.child.product.ty !== 1 || _vm.child.product.dp !== 0
                ? _c("div", { staticClass: "fsize-11 color-bo-s2" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.ShopService.prix(_vm.child.product.dp)) +
                        "\n\t\t\t"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "activation" },
                [
                  _c("Switch2", {
                    on: { input: _vm.activateProduct },
                    model: {
                      value: _vm.child.product.av,
                      callback: function ($$v) {
                        _vm.$set(_vm.child.product, "av", $$v)
                      },
                      expression: "child.product.av",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }